import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import {
  ItemRenderProps,
  SortableItemProps,
  SortableList
} from '@thaddeusjiang/react-sortable-list';
import { useDispatch, useSelector } from 'react-redux';
import {
  getVideoThumbnail,
  isMediaImage,
  isMediaVideo
} from '../../../../redux/slices/lomavisCreator/utils';
import ProgressBar from 'react-bootstrap/ProgressBar';
import {
  setUploadAreaVisibility,
  updateUseSeparateMediaFiles
} from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import { Form } from 'react-bootstrap';
import { lomavisCreatorRootState } from '../../../../pages/lomavisCreator';
import { useTranslate } from '@tolgee/react';
import {
  ALL,
  PLATFORM_LIST,
  PLATFORMS_COLORS
} from '../../../../config/constants';
import {
  PLATFORM_COLORS,
  PLATFORM_DISPLAY_NAME_KEYS,
  PLATFORM_ICONS
} from '../../../../config/icons';
import MediaUploadBox from './MediaBox';
import CreatorCard from '../commonElements/creatorCard';
import CreatorTitle from '../commonElements/creatorTitle';
import CreatorSwitchButton from '../commonElements/creatorSwitchButton';
import toast from 'react-hot-toast';
import ImageWithLoading from '../commonElements/imageWithLoading';

interface Props {
  sortableListRef: React.MutableRefObject<any>;
}

const MediaUploadArea: React.FC<Props> = ({ sortableListRef }) => {
  const dispatch = useDispatch();

  const { t } = useTranslate();

  const divRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isCovered, setIsCovered] = useState(false);
  const useSeparateMediaFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.useSeparateMediaFiles
  );
  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );
  const { postData } = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  // useEffect(() => {
  //   console.warn(isVisible, isCovered);
  //   if (isVisible && !isCovered) {
  //     dispatch(setUploadAreaVisibility({ visible: true }));
  //   } else {
  //     dispatch(setUploadAreaVisibility({ visible: false }));
  //   }
  // }, [isVisible, isCovered]);

  return (
    <CreatorCard>
      <div
        ref={divRef}
        className="d-flex justify-content-between align-items-center mb-2 w-100"
      >
        <CreatorTitle title="media" tooltipLink={t(`lomavisCreator.link.link_file_limits`)} />

        <div className="d-flex align-items-center">
          <CreatorSwitchButton
            tooltipText={t('lomavisCreator.mediaUploadArea.switch_tooltip')}
            isOn={useSeparateMediaFiles}
            onClick={() => {
              // if media files are selected, show toast you can't switch
              // postData = {platform:{media:[]}}
              const allMedia = [];
              Object.values(postData).map((platform) => {
                allMedia.push(...platform.media);
              });
              if (allMedia.length > 0) {
                toast.error(t('lomavisCreator.mediaUploadArea.switchError'), {
                  duration: 5000,
                  position: 'top-right'
                });
                return;
              }
              dispatch(updateUseSeparateMediaFiles(!useSeparateMediaFiles));
            }}
            OnText={t('lomavisCreator.mediaUploadArea.individual')}
          />
        </div>
      </div>

      {!useSeparateMediaFiles && (
        <MediaUploadBox platform={ALL} sortableListRef={sortableListRef} />
      )}

      {useSeparateMediaFiles &&
        PLATFORM_LIST.map(
          (platform) =>
            platformEnabled[platform] && (
              <MediaUploadBox
                platform={platform}
                sortableListRef={sortableListRef}
              />
            )
        )}
    </CreatorCard>
  );
};

export default MediaUploadArea;
